import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CbjGalleryItemComponent } from './core/cbj-gallery-item.component';
import { CbjGalleryComponent } from './core/cbj-gallery.component';
import { CbjFilterGalleryComponent } from './filterable/cbj-filter-gallery.component';
import { CbjMenuModule } from '../menu/index';
export class CbjGalleryModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
    CbjMenuModule,
  ],
  declarations: [
    CbjGalleryItemComponent,
    CbjGalleryComponent,
    CbjFilterGalleryComponent,
  ],
  exports: [
    CbjGalleryItemComponent,
    CbjGalleryComponent,
    CbjFilterGalleryComponent,
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function CbjGalleryModule_tsickle_Closure_declarations() {
/** @type {?} */
CbjGalleryModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CbjGalleryModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
